(function(app, ng) {

    app.component("eventPerformanceTable",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Components/EventPerformanceTable/event-performance-table.component.html",
            controller: eventPerformanceTableController,
            bindings: {
                events: "<",
                isExporting: "<",
                onExport: "&",
                onCheckResponseRate: "&",
                onCheckNoShowRate: "&",
                onCheckApptSetRate: "&",
                onCheckPersistencyRate: "&",
                onCheckCloseRate: "&",
                onCheckAverageCaseSize: "&"
            }
        });

    eventPerformanceTableController.$inject = ["featureToggleService"];
    function eventPerformanceTableController(featureToggleService) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                environment: featureToggleService.checkEnv(),
                sortOn: "date",
                sortDesc: false,
                sortBy: function(sortOn) {
                    if ($ctrl.sortFunctions[sortOn]) {

                        var sortDesc = false;
                        if ($ctrl.sortOn === sortOn) {
                            sortDesc = !$ctrl.sortDesc;
                            $ctrl.copiedEvents = $ctrl.copiedEvents.reverse();
                        } else {
                            var compareFunction = $ctrl.sortFunctions[sortOn];
                            $ctrl.copiedEvents = $ctrl.copiedEvents.sort(compareFunction);
                        }

                        $ctrl.sortOn = sortOn;
                        $ctrl.sortDesc = sortDesc;
                    } else {
                        console.log("No sort function for this column.");
                    }
                },
                sortFunctions: {
                    _standard: function (a, b, propertyName) {
                        if (a[propertyName] < b[propertyName])
                            return -1;
                        if (a[propertyName] > b[propertyName])
                            return 1;
                        return 0;
                    },
                    date: function (a, b) {
                        if (a.date.isBefore(b.date))
                            return -1;
                        if (a.date.isAfter(b.date))
                            return 1;
                        return 0;
                    },
                    title: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "title");
                    },
                    totalSpent: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "totalSpent");
                    },
                    totalInsuranceBusinessClosed: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "totalInsuranceBusinessClosed");
                    },
                    totalCommission: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "totalCommission");
                    },
                    responseRate: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "responseRate");
                    },
                    noShowRate: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "noShowRate");
                    },
                    appointmentSetRate: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "appointmentSetRate");
                    },
                    persistencyRate: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "persistencyRate");
                    },
                    closeRate: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "closeRate");
                    },
                    averageCaseSize: function (a, b) {
                        return $ctrl.sortFunctions._standard(a, b, "averageCaseSize");
                    }
                }
            });

        function sort() {
            var compareFunction = $ctrl.sortFunctions[$ctrl.sortOn];
            $ctrl.copiedEvents = $ctrl.copiedEvents.sort(compareFunction);
            if ($ctrl.sortDesc) {
                $ctrl.copiedEvents = $ctrl.copiedEvents.reverse();
            }
        };

        $ctrl.$onInit = function() {
            $ctrl.sortOn = "date";
            $ctrl.sortDesc = false;
            if ($ctrl.events instanceof Array) {
                $ctrl.copiedEvents = $ctrl.events.slice();
            } else {
                $ctrl.copiedEvents = [];
            }
            sort();
        };

        $ctrl.$onChanges = function(changes) {
            if (changes.events && changes.events.currentValue instanceof Array) {
                if (!changes.events.isFirstChange()) {
                    $ctrl.copiedEvents = changes.events.currentValue.slice();
                    sort();
                }
            }
        };
    }

})(window.app, window.angular); //jshint ignore:line